<div class="flx-alert" [ngClass]="styleClasses.typeclass">
	<flx-icon class="alert-icon" [type]="iconType" [color]="iconColor" [isClickable]="false" [instruction]="type === 'no-info' ? 'No items to display' : message"></flx-icon>
	<p>{{ type === 'no-info' ? 'No ' + missingItem + ' available.' : message }}</p>
</div>
